var _defs, _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTextBwVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 188.2989 24.020838",
    id: "svg57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs51"
  })), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(126.65541,77.022321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -118.02821,-53.001484 c 5.85297,0 8.52571,-2.909566 8.52571,-6.258951 0,-8.59337 -14.78466,-4.398181 -14.78466,-11.502936 0,-2.605077 2.06377,-4.736503 6.66494,-4.736503 2.13143,0 4.53351,0.642811 6.49578,1.996098 l 0.64281,-1.387119 c -1.82694,-1.319454 -4.53351,-2.131426 -7.13859,-2.131426 -5.81913,0 -8.39038,2.943398 -8.39038,6.292782 0,8.728699 14.78466,4.465846 14.78466,11.570601 0,2.571244 -2.09759,4.635006 -6.8341,4.635006 -3.18022,0 -6.19128,-1.285622 -7.81523,-2.97723 l -0.77814,1.285622 c 1.72544,1.894601 5.10866,3.214056 8.6272,3.214056 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -87.930658,-74.958559 9.912824,21.787914 h 1.860769 l -5.243986,-11.333775 -5.649971,-12.348741 h -1.725441 l -10.893955,23.682516 h 1.860769 l 8.390375,-18.506194 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -63.922875,-53.170645 h 1.725441 v -23.682516 h -1.725441 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -46.004945,-53.170645 h 15.359803 v -1.55628 h -13.634362 v -22.126236 h -1.725441 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m -3.9308526,-76.853161 h -1.7931047 l -8.5595427,13.938852 -8.559538,-13.938852 h -1.894601 l 9.54067,15.528964 v 8.153552 h 1.725441 v -8.153552 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.287005,-76.853161 v 20.569957 L 9.1828942,-76.853161 H 7.7281111 v 23.682516 h 1.7254404 v -20.569956 l 16.1379425,20.569956 h 1.420951 v -23.682516 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 53.219293,-53.001484 c 3.349384,0 6.360447,-1.116462 8.424209,-3.315552 l -1.082629,-1.116462 c -2.02993,1.996098 -4.499678,2.841902 -7.273916,2.841902 -6.055957,0 -10.623299,-4.465846 -10.623299,-10.420307 0,-5.954461 4.567342,-10.420307 10.623299,-10.420307 2.774238,0 5.243986,0.811972 7.273916,2.80807 l 1.082629,-1.116461 c -2.063762,-2.199091 -5.074825,-3.28172 -8.424209,-3.28172 -7.03709,0 -12.281076,5.108657 -12.281076,12.010418 0,6.901762 5.243986,12.010419 12.281076,12.010419 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "25.4px",
      lineHeight: 1.25,
      fontFamily: "Montserrat",
      InkscapeFontSpecification: "'Montserrat, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      letterSpacing: "5.9592px",
      whiteSpace: "pre",
      shapeInside: "url(#rect853-7)",
      fill: "#f55b29",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.33197
    },
    id: "path31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextBwVector);
export default __webpack_public_path__ + "static/media/logo_text_bw_vector.5db1cf10e4656fbc3eea40c60d4315da.svg";
export { ForwardRef as ReactComponent };